import React from 'react'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import Select from 'orionsoft-parts/lib/components/fields/Select'

export default function Zone({countryCode, ...props}) {
  const {zones} = useQuery({
    query: gql`
      query getZones($countryCode: String) {
        zones(countryCode: $countryCode) {
          _id
          items {
            value: _id
            label: name
          }
        }
      }
    `,
    variables: {
      ...(countryCode ? {countryCode} : {})
    }
  })

  return <Select placeholder="Selecciona una zona" {...props} options={zones.items} />
}
